export const WixCodeAppDefId = '675bbcef-18d8-41f5-800e-131ec9e08762'
export const WixCodeSentryDsn = 'https://760a5dce5978409b86a97e1ccd21aa7a@sentry.wixpress.com/154'
export const MasterPageId = 'masterPage'

export const EVENT_CONTEXT_SCOPE = {
	GLOBAL_SCOPE: 'GLOBAL_SCOPE',
	COMPONENT_SCOPE: 'COMPONENT_SCOPE',
}

export const ACTION_TYPES = {
	CLICK: 'click',
	DBL_CLICK: 'dblClick',
	MOUSE_IN: 'mouseenter',
	MOUSE_OUT: 'mouseleave',
	CHANGE: 'change',
	BLUR: 'blur',
	FOCUS: 'focus',
	IMAGE_CHANGED: 'imageChanged',
	IMAGE_EXPANDED: 'imageExpanded',
	ON_INPUT: 'onInput',
	ITEM_CLICKED: 'itemClicked',
	CELL_SELECT: 'cellSelect',
	CELL_EDIT: 'cellEdit',
	ROW_SELECT: 'rowSelect',
	FETCH_DATA: 'fetchData',
	DATA_CHANGE: 'dataChange',
	ON_TIMEOUT: 'onTimeout',
	ON_VERIFY: 'onVerified',
	ON_ERROR: 'onError',
	ON_PLAY: 'onPlay',
	ON_PAUSE: 'onPause',
	ON_PROGRESS: 'onProgress',
	ON_ENDED: 'onEnded',
	AUTOPLAY_OFF: 'autoplayOff',
	AUTOPLAY_ON: 'autoplayOn',
	PLAY_ENDED: 'playEnded',
	PLAY_PROGRESS: 'playProgress',
	KEY_PRESS: 'keyPress',
	SCREEN_IN: 'screenIn',
	VIEWPORT_ENTER: 'viewportEnter',
	VIEWPORT_LEAVE: 'viewportLeave',
	SCROLL: 'scroll',
	VALIDATE: 'validate',
	SET_CUSTOM_VALIDITY: 'setCustomValidity',
	SYNC_VALIDATION_DATA: 'syncValidationData',
	UPDATE_VALIDITY_INDICATION: 'updateValidityIndication',
	MESSAGE: 'message',
	UPLOAD_COMPLETE: 'uploadComplete',
	ITEM_READY: 'itemReady',
	ITEM_REMOVED: 'itemRemoved',
	TAG_CLICK: 'tagClick',
	QUICK_ACTION_BAR_ITEM_CLICKED: 'quickActionBarItemClicked',
	GOOGLE_MAP_MARKER_CLICKED: 'markerClicked',
	GOOGLE_MAP_CLICKED: 'mapClicked',
	ICON_MOUSE_IN: 'iconMouseIn',
	ON_STATE_CHANGE: 'onStateChange',
}

export const EVENT_TYPES_MAP = {
	[ACTION_TYPES.CLICK]: 'onClick',
	[ACTION_TYPES.DBL_CLICK]: 'onDblClick',
	[ACTION_TYPES.MOUSE_IN]: 'onMouseIn',
	[ACTION_TYPES.MOUSE_OUT]: 'onMouseOut',
	[ACTION_TYPES.CHANGE]: 'onChange',
	[ACTION_TYPES.ON_INPUT]: 'onInput',
	[ACTION_TYPES.BLUR]: 'onBlur',
	[ACTION_TYPES.FOCUS]: 'onFocus',
	[ACTION_TYPES.IMAGE_CHANGED]: 'onCurrentItemChanged',
	[ACTION_TYPES.IMAGE_EXPANDED]: undefined,
	[ACTION_TYPES.ITEM_CLICKED]: 'onItemClicked',
	[ACTION_TYPES.CELL_SELECT]: 'onCellSelect',
	[ACTION_TYPES.CELL_EDIT]: undefined,
	[ACTION_TYPES.ROW_SELECT]: 'onRowSelect',
	[ACTION_TYPES.FETCH_DATA]: undefined,
	[ACTION_TYPES.DATA_CHANGE]: 'onDataChange',
	[ACTION_TYPES.ON_TIMEOUT]: 'onTimeout',
	[ACTION_TYPES.ON_VERIFY]: 'onVerified',
	[ACTION_TYPES.ON_ERROR]: 'onError',
	[ACTION_TYPES.ON_PLAY]: 'onPlay',
	[ACTION_TYPES.ON_PAUSE]: 'onPause',
	[ACTION_TYPES.ON_PROGRESS]: 'onProgress',
	[ACTION_TYPES.ON_ENDED]: 'onEnded',
	[ACTION_TYPES.AUTOPLAY_OFF]: 'onPause',
	[ACTION_TYPES.AUTOPLAY_ON]: 'onPlay',
	[ACTION_TYPES.PLAY_ENDED]: undefined,
	[ACTION_TYPES.PLAY_PROGRESS]: undefined,
	[ACTION_TYPES.KEY_PRESS]: 'onKeyPress',
	[ACTION_TYPES.SCREEN_IN]: undefined,
	[ACTION_TYPES.VIEWPORT_ENTER]: 'onViewportEnter',
	[ACTION_TYPES.VIEWPORT_LEAVE]: 'onViewportLeave',
	[ACTION_TYPES.SCROLL]: undefined,
	[ACTION_TYPES.VALIDATE]: undefined,
	[ACTION_TYPES.SET_CUSTOM_VALIDITY]: undefined,
	[ACTION_TYPES.SYNC_VALIDATION_DATA]: undefined,
	[ACTION_TYPES.UPDATE_VALIDITY_INDICATION]: undefined,
	[ACTION_TYPES.MESSAGE]: 'onMessage',
	[ACTION_TYPES.UPLOAD_COMPLETE]: undefined,
	[ACTION_TYPES.ITEM_READY]: 'onItemReady',
	[ACTION_TYPES.ITEM_REMOVED]: 'onItemRemoved',
	[ACTION_TYPES.TAG_CLICK]: undefined,
	[ACTION_TYPES.QUICK_ACTION_BAR_ITEM_CLICKED]: 'onItemClicked',
	[ACTION_TYPES.GOOGLE_MAP_MARKER_CLICKED]: 'onMarkerClicked',
	[ACTION_TYPES.GOOGLE_MAP_CLICKED]: 'onMapClicked',
	[ACTION_TYPES.ICON_MOUSE_IN]: undefined,
	[ACTION_TYPES.ON_STATE_CHANGE]: 'onStateChange',
}
